import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-campaign-total-price-summary-section',
    templateUrl: './campaign-total-price-summary-section.component.html',
    styleUrls: ['./campaign-total-price-summary-section.component.scss']
})
export class CampaignTotalPriceSummarySection {
    @Input() sectionData: any[];

    constructor() {}
}
